import React from "react";
import { Grid, Box, Typography, IconButton, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';

// disabledClose
const ModalHeader = ({
  title,
  mode,
  handleClose,
  modalExitFullWidth,
  modalFullWidth,
  modalIsFull,
  disabledClose=false
}) => {

  const renderTitle = () => {
    switch (mode) {
      case "add":
        return (
          <Typography
            variant="body1"
            fontWeight={900}
          >{` افزودن ${title}`}</Typography>
        );
        break;

      case "edit":
        return <Typography>{` ویرایش ${title}`}</Typography>;
        break;
      case "delete":
        return <Typography>{` حذف ${title}`}</Typography>;
        break;
    }
  };

  

  return (
    <Grid container mb={1}>
      <Grid item flexGrow={2} py={1} px={2}>
        <Box>{renderTitle()}</Box>
      </Grid>
      <Grid item py={1}>
        <Box>
          {modalIsFull ? (
            <Button onClick={modalExitFullWidth}> <i className="icon-Minimize-Square-2"></i></Button>
          ) : (
            <Button onClick={modalFullWidth}> <i className="icon-Maximize-Square-2"></i> </Button>
          )}
          <IconButton 
          disabled={disabledClose} 
          size="small" onClick={handleClose}>
            <CloseIcon  sx={{color:"red"}}/>
          </IconButton>
        </Box>
      </Grid>
    </Grid>
  );
};

export default ModalHeader;
